import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { CheckCircleIcon } from 'lucide-react';

interface FeedbackSentDialogProps {
  open: boolean;
  onContinueEditing: () => void;
  onReturnToCase: () => void;
}

function FeedbackSentDialog({ open, onContinueEditing, onReturnToCase }: FeedbackSentDialogProps) {
  return (
    <Dialog open={open} maxWidth='xs' fullWidth>
      <DialogContent sx={{ padding: '32px', textAlign: 'center' }}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: '#D1FAE5',
            marginBottom: '8px',
          }}
        >
          <CheckCircleIcon size={32} color='#059669' />
        </Box>

        <Typography variant='h6' sx={{ fontWeight: 700, marginBottom: '8px' }}>
          Feedback Sent
        </Typography>

        <Typography variant='body2' sx={{ color: 'text.secondary' }}>
          Your error report has been submitted successfully. The team will review your feedback.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px', justifyContent: 'center', gap: '8px' }}>
        <Button variant='outlined' disableElevation onClick={onContinueEditing}>
          Continue to edit filters
        </Button>
        <Button variant='contained' disableElevation color='primary' onClick={onReturnToCase}>
          Return to case page
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FeedbackSentDialog;
